import { IonPopover } from '@ionic/react';
import React, {
  MouseEventHandler,
  ReactElement,
  ReactNode,
  useCallback,
  useState,
} from 'react';
import { BaseButton } from './base-button';

import './action-bar-icon.css';

export interface ActionBarIconProps {
  disabled?: boolean;
  onToggle?: () => void;
  isHighlighted: boolean;
  children: ReactNode;
  popoverContents?: ReactElement;
  popoverClassName?: string;
  onClick?: () => void;
}

const ActionBarIcon = (props: ActionBarIconProps): ReactElement => {
  const {
    isHighlighted,
    onToggle,
    disabled,
    popoverContents,
    popoverClassName,
    children,
    onClick,
  } = props;

  const [popoverState, setShowPopover] = useState<{
    showPopover: boolean;
    event: React.MouseEvent<HTMLIonButtonElement, MouseEvent> | undefined;
  }>({ showPopover: false, event: undefined });

  const dismiss = useCallback(() => {
    setShowPopover({ showPopover: false, event: undefined });
  }, []);

  const onClickHandler: MouseEventHandler<HTMLIonButtonElement> = (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (typeof onClick === 'function') {
      onClick();
      return;
    }

    if (onToggle) {
      onToggle();
    }
    if (popoverContents) {
      setShowPopover({ showPopover: true, event });
    }
  };

  return (
    <>
      <IonPopover
        event={popoverState.event}
        isOpen={popoverState.showPopover}
        onDidDismiss={() => dismiss()}
        className={popoverClassName}
      >
        {popoverContents && React.cloneElement(popoverContents, { dismiss })}
      </IonPopover>
      <BaseButton
        className="action-bar-button-icon"
        buttonProps={{
          fill: isHighlighted && !disabled ? 'solid' : 'clear',
          disabled,
          color: disabled ? 'medium' : 'primary',
          slot: 'end',
          size: 'small',
          onClick: onClickHandler,
        }}
      >
        {children}
      </BaseButton>
    </>
  );
};

export { ActionBarIcon };
